/* global window */
import React from 'react';
import PropTypes from 'prop-types';
import { NewRadio } from 'panamera-react-ui';
import classnames from 'classnames';
import css from './PriceCardTab.scss';

const PriceCardTab = props => {
    const { isActive, handleClickTab, id, enableEmiFeature, isMarkedInterest } = props;

    return (
        <div data-aut-id="priceCardTab" className={ css.priceCardTab }>
            {enableEmiFeature && !isMarkedInterest && (
                <NewRadio
                    id={ id }
                    onClick={ handleClickTab }
                    checked={ typeof window !== 'undefined' && isActive }
                    className={ css.radio }
                />
            )}
            <div
                className={ classnames(css.tabInfo, {
                    [css.ml0]: !enableEmiFeature || isMarkedInterest
                }) }
            >
                {props.children}
            </div>
        </div>
    );
};

PriceCardTab.propTypes = {
    children: PropTypes.oneOfType([PropTypes.element, PropTypes.array, PropTypes.string]),
    isActive: PropTypes.bool,
    handleClickTab: PropTypes.func,
    id: PropTypes.string,
    enableEmiFeature: PropTypes.bool,
    isMarkedInterest: PropTypes.bool
};

PriceCardTab.defaultProps = {
    children: <></>,
    isActive: false,
    handleClickTab: () => {},
    enableEmiFeature: false,
    isMarkedInterest: false
};

export default PriceCardTab;
